import "./EditButtonGroup.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faRotateLeft } from "@fortawesome/free-solid-svg-icons";

const EditButtonGroup = ({
	className = "",
	onEdit,
	show = true,
	showUndo = false,
	showEdit = true,
	onUndo
}) => {
	const containerClassName = `edit-button-group ${className}`.trim();

	const handleKeyboardActivation = (callback) => (keyboardEvent) => {
		if (!callback) {
			return;
		}
		const { key } = keyboardEvent;
		if (key === "Enter" || key === " ") {
			keyboardEvent.preventDefault();
			callback(keyboardEvent);
		}
	};

	if (!show) {
		return null;
	}

	return (
		<div className={containerClassName}>
			{showEdit && (
				<div
					className="edit-button-group__item edit-button-group__edit"
					role="button"
					tabIndex={0}
					aria-label="Edit"
					onClick={onEdit}
					onKeyDown={handleKeyboardActivation(onEdit)}
				>
					<FontAwesomeIcon icon={faPenToSquare} />
				</div>
			)}

			{showUndo && (
				<div
					className="edit-button-group__item edit-button-group__undo"
					role="button"
					tabIndex={0}
					aria-label="Undo changes"
					onClick={onUndo}
					onKeyDown={handleKeyboardActivation(onUndo)}
				>
					<FontAwesomeIcon icon={faRotateLeft} />
				</div>
			)}
		</div>
	);
};

export default EditButtonGroup;
